(function () {
  'use strict';

  // Produkttitel mit gewaehlter Ausstattung (18.10.2026), Gegenstueck zu snippets/th-variant-title.liquid.
  // global.js feuert beim Variantenwechsel ein bubbelndes change-Event am input[name="id"].
  // Bewusst ohne Initialisierung beim Laden: Die Schnellansicht ("Optionen auswaehlen" in Suche und
  // Kollektionen) laedt die Produktseite erst spaeter in ein Fenster (Hinweis Agron 18.10.). Gesucht wird
  // darum beim Wechsel der naechste Vorfahre des Eingabefelds, der einen Titel mit Variantenkarte enthaelt.

  document.addEventListener('change', function (event) {
    const input = event.target.closest && event.target.closest('input[name="id"]');
    if (!input) return;
    let box = input.parentElement;
    while (box && !box.querySelector('[data-th-variant-title]')) box = box.parentElement;
    if (!box) return;
    const heading = box.querySelector('[data-th-variant-title]');
    const mapEl = box.querySelector('[data-th-variant-title-data]');
    let map = {};
    try {
      if (mapEl) map = JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      map = {};
    }
    const title = map[String(input.value)];
    if (title) heading.textContent = title;
  });
})();
